import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@/b2b/context/ThemeContext"; // Dynamic Theme Context
import { chatHelpMessage } from "@/lib/helper";
import { headingVariants } from "@/lib/data";
import { motion } from "framer-motion";
import HousrLogo from "@/assets/icons/b2b/housr-logo.svg";
import GoBackButton from "@/components/common/buttons/GoBackButton.jsx";
import Stepper from "@/components/common/Header/stepper.jsx";
import WhatsappIcon from "@/assets/icons/whatsapp-icon-green.svg";
import ProfileIcon from "@/assets/icons/f7_person-fill.svg";
import HWLogo from "@/assets/icons/b2b/hello-world.svg";
import MS from "@/assets/icons/b2b/meridianstays.svg";
import NestAway from "@/assets/icons/b2b/nestaway.jpg";
import Stanza from "@/assets/icons/b2b/stanza-logo.svg";
import FabHostel from "@/assets/icons/b2b/fabhostels-logo.png";
import Kots from "@/assets/icons/b2b/kots.svg";
import Oxotel from "@/assets/icons/b2b/oxotel.webp";
import Tribe from "@/assets/icons/b2b/tribe.svg";
import Truliv from "@/assets/icons/b2b/truliv.svg";
import Friendzo from "@/assets/icons/b2b/friendzo.png";
import capacity_capital from "@/assets/icons/b2b/capacity_capital.jpeg";
import Youthville from "@/assets/icons/b2b/youthville.jpg";
import UrbanRoomz from "@/assets/icons/b2b/urbanroomz-logo.png";
import FlentLogo from "@/assets/icons/b2b/flent-logo.svg";
import BlossomStayz from "@/assets/icons/b2b/blossom_stayz_transparent.png";
import { Headset, RefreshCcw, X } from "lucide-react";
import { HamburgerMenuIcon } from "@radix-ui/react-icons";

const Header = ({
  total,
  progress,
  customBackSubmit,
  heading,
  subheading,
  showChat = false,
  showProfile = false,
  showBackButton = true,
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [openMenu, setOpenMenu] = useState(false);

  const getLogo = (name) => {
    switch (name) {
      case "housr":
        return (
          <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd]">
            {" "}
            <img src={HousrLogo} alt="logo" className="max-h-5 pb-1" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "xu":
        return (
          <div className="flex items-center">
            <img
              src="https://s3.us-east-1.amazonaws.com/circleapp.in/xucirclepe.svg"
              alt="logo"
              className="max-h-8"
            />
          </div>
        );
      case "hw":
        return (
          <div className="flex items-center">
            {" "}
            <img src={HWLogo} alt="logo" className="max-h-8" />
          </div>
        );
      case "meridianstays":
        return (
          <div className="flex items-center">
            {" "}
            <img src={MS} alt="logo" className="max-h-8" />
          </div>
        );
      case "nestaway":
        return (
          <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd] w-full">
            <img src={NestAway} className="max-h-14" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "stanza":
        return (
          <div className="flex gap-1 ml-2 items-center text-2xl font-thin text-[#ddd] w-full">
            <img src={Stanza} className="max-h-10" />|
            <div className="text-sm font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "fabhostels":
        return (
          <div className="flex gap-1 ml-2 items-center text-2xl font-thin text-[#ddd] w-full">
            <img src={FabHostel} className="max-h-10" />|
            <div className="text-sm font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "kots":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Kots} className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "oxotel":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Oxotel} className="max-h-6" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "tribe":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Tribe} className="max-h-6" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "truliv":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Truliv} className="max-h-6" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "friendzo":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Friendzo} className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "capacity_capital":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={capacity_capital} className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "youthville":
        return (
          <div className="flex gap-1 items-center justify-end text-2xl font-thin text-[#ddd] w-full">
            <img src={Youthville} className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "urbanroomz":
        return (
          <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd]">
            <img src={UrbanRoomz} alt="logo" className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "flent":
        return (
          <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd]">
            <img src={FlentLogo} alt="logo" className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      case "blossomstayz":
        return (
          <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd]">
            <img src={BlossomStayz} alt="logo" className="max-h-8" />|
            <div className="text-lg font-medium text-[#010101]">
              Circle<span className="text-[#0031fb]">Pe</span>
            </div>
          </div>
        );
      default:
        return (
          <div className="text-lg font-medium text-black bg-[#ffffff]">
            Circle<span className="text-[#0000cc]">Pe</span>
          </div>
        );
    }
  };

  return (
    <div className={`flex flex-col gap-8 w-full ${theme?.backgroundColor}`}>
      <div className="flex flex-col justify-center items-center ">
        <div className="relative flex flex-row gap-4 w-full justify-between items-center">
          {showBackButton ? (
            <GoBackButton customBackSubmit={customBackSubmit} />
          ) : null}
          <div className="flex items-center justify-between w-full">
            {theme?.logoUrl ? (
              // DB-driven partner: render the logo uploaded from the dashboard,
              // co-branded with CirclePe like the hardcoded partners.
              <div className="flex gap-1 items-center text-2xl font-thin text-[#ddd]">
                <img src={theme.logoUrl} alt="logo" className="max-h-8" />|
                <div className="text-lg font-medium text-[#010101]">
                  Circle<span className="text-[#0031fb]">Pe</span>
                </div>
              </div>
            ) : (
              theme?.logo && getLogo(theme?.name)
            )}
            {showChat && (
              <button
                onClick={() => chatHelpMessage()}
                className={`flex flex-col p-1 px-2 justify-between items-center  rounded-full`}
              >
                <img src={WhatsappIcon} alt="chat-icon" className="size-10" />
                {/* <span className={`text-xs text-black`}>
                  Chat
                </span> */}
              </button>
            )}

            <button
              onClick={() => setOpenMenu(!openMenu)}
              className="flex flex-col p-1 px-2 justify-between items-center rounded-full text-black/80"
            >
              {openMenu ? (
                <X color="#777" size={24} />
              ) : (
                <HamburgerMenuIcon className="size-6" />
              )}
            </button>
            {openMenu && (
              <div className="absolute top-full mt-2 right-0 w-48 bg-white text-black border rounded-lg shadow-md z-50">
                <button
                  onClick={() => chatHelpMessage()}
                  className="w-full flex items-center justify-start min-w-max text-left px-4 py-2 gap-2 hover:bg-gray-100"
                >
                  <img src={WhatsappIcon} alt="chat-icon" className="size-9" />{" "}
                  Support
                </button>
                <button
                  onClick={() => {
                    // window.location.reload();
                    // window.location.href = window.location.origin + window.location.pathname ;
                    // navigate(0);
                    // 1️⃣ Drop the search part of the URL
                    const { pathname, hash } = window.location;
                    window.history.replaceState({}, "", pathname + hash);

                    // 2️⃣ Hard-reload the page
                    window.location.reload();
                  }}
                  className="w-full flex items-center justify-start min-w-max text-left px-5 py-2 gap-4 hover:bg-gray-100"
                >
                  <RefreshCcw color="#0031fb" /> Refresh
                </button>
              </div>
            )}
            {showProfile && (
              <button onClick={() => navigate("/profile")}>
                <img src={ProfileIcon} alt="profile-icon" className="" />
              </button>
            )}
          </div>
        </div>
        {total && (
          <div className="flex flex-col w-1/3">
            <Stepper steps={total} currentStep={progress} />
          </div>
        )}
      </div>
      {(heading || subheading) && (
        <div className="flex flex-col">
          {heading && (
            <motion.h1
              className="reveal-heading"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              <span
                className={`text-xl font-medium ${theme?.headingColor}`}
                style={
                  !theme?.headingColor && theme?.headingColorCode
                    ? { color: theme.headingColorCode }
                    : undefined
                }
              >
                {heading}
              </span>
            </motion.h1>
          )}
          {subheading && (
            <motion.h1
              className="reveal-heading"
              initial="hidden"
              animate="visible"
              variants={headingVariants}
            >
              <span className={`text-base ${theme?.subHeadingColor}`}>
                {subheading}
              </span>
            </motion.h1>
          )}
        </div>
      )}
    </div>
  );
};

export default Header;
